import React from 'react';
import { FormBlock } from './index';
import { FormBlockSection } from 'src/components/Form/elements';
import FormIntroText from './FormIntroText';
/* --- import Style ----*/
import { mediaQueries } from 'src/style/breakpoints';
/* --- import Utils ----*/
import { useRestoreFormManager } from 'src/utils/RestoreForm';

// const FORM_NAME = 'event-form-completed';

const FormSteps = ({
  dataFromMeetup,
  selectedEvent,
  pageType,
  formEndOfPage,
  noPhoto,
  formCompleted,
  setFormCompleted,
}) => {
  const manager = useRestoreFormManager();

  return (
    <FormBlockSection
      landing={pageType === 'landingPage'}
      css={{
        padding: pageType !== 'landingPage' && '0 30px 35px 30px',
        flex: 1,
        [mediaQueries.tabletLandscapeUp]: {
          padding: pageType !== 'landingPage' && '0 60px 55px 60px',
        },
      }}
    >
      {pageType === 'landingPage' && !formCompleted && (
        <FormIntroText
          selectedEvent={selectedEvent}
          formEndOfPage={formEndOfPage}
          noPhoto={noPhoto}
        />
      )}
      <FormBlock
        pageType={pageType}
        dataFromMeetup={dataFromMeetup}
        selectedEvent={selectedEvent}
        formCompleted={formCompleted}
        setFormCompleted={setFormCompleted}
        manager={manager}
      />
    </FormBlockSection>
  );
};

export default FormSteps;
